import React, { Component } from 'react';
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import { connect } from "react-redux";
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import { addItem } from '../../actions/auction_action';
import { setProfileError } from '../../actions/profile_action';
import LoadingButton from '../fields/LoadingButton';
import route from '../../config/routes';
import Service from '../../helpers/service';
import $ from 'jquery';

const { CREATE, EMPTY } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageTitle: 'Create Auction',
            buttonTitle: 'Save',
            buy_now_amount: '',
            reserve_price: '',
            auction_start_amount: '',
            type: 'hours',
            expire_duration: '',
            nft_id: '',
            title: '',
            url: API_URL.ADMIN_TRADING_API + route.GET_AUCTION,
            routeName: '',
            error_message: '',
            error_type: '',
            isLoading: false,
            btnIsDisable: false
        };

        this.onSave = this.onSave.bind(this);
    }

    handleChange = async ({ target }) => {
        const { value, name } = target;
        let data = { [name]: value };
        this.setState({ [name]: value });

        if (name === "buy_now_amount" || name === "reserve_price" || name === "auction_start_amount") {
            let errorObject;
            this.setState({ ...await validateField("decimal", name, value, "", 1), ...errorObject })
        }

        else if (name === "type") {
            let errorObject;
            this.setState({ ...await validateField("string", name, value, "", 1), ...errorObject })
        }

        else if (name === "expire_duration") {
            let errorObject;
            this.setState({ ...await validateField("numeric", name, value, "", 1), ...errorObject })
        }

        else if (name === "nft_id") {
            let errorObject;
            this.setState({ ...await validateField("numeric", name, value, "", 1), ...errorObject })
        }
        this.setState({ ...data })
    }

    componentDidMount() {
        let that = this;

        $(".close-slide").click(function () {
            that.resetForm();
            that.removeNetworkError();
            that.props.closeModal();
        });
        this.setErrorOnApiCall();
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.nft_id.length === 0) {
            let errorObject = setErrorFields("nft_id", Helping.getMessageString(EMPTY, "Nft ID"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (state.buy_now_amount.length === 0) {
            let errorObject = setErrorFields("buy_now_amount", Helping.getMessageString(EMPTY, "Buy now"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (state.reserve_price.length === 0) {
            let errorObject = setErrorFields("reserve_price", Helping.getMessageString(EMPTY, "Reserve price"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (state.auction_start_amount.length === 0) {
            let errorObject = setErrorFields("auction_start_amount", Helping.getMessageString(EMPTY, "Auction start amount"));
            this.setState(errorObject);
            formHasError = true;
        }
        if (Number(state.expire_duration) === 0) {
            let errorObject = setErrorFields("expire_duration", Helping.getMessageString(EMPTY, "Expire Duration"));
            this.setState(errorObject);
            formHasError = true;
        }

        return formHasError;
    }

    scrollToTop = () => {
        $('.addButton-slide').animate({ scrollTop: 0 }, 'slow');
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    resetForm = () => {
        this.setState({
            nft_id: '',
            buy_now_amount: '',
            reserve_price: '',
            auction_start_amount: '',
            type: 'hours',
            expire_duration: '',
            isLoading: true,
            btnIsDisable: false,
            error_auction_start_amount_message: '',
            error_buy_now_amount_message: '',
            error_expire_duration_message: '',
            error_nft_id_message: '',
            error_type_message: '',
            error_reserve_price_message: ''
        })
    }

    onSave(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: "create",
            itemDetailId: Number($this.state.nft_id),
            startAmount: Number($this.state.auction_start_amount),
            reservedAmount: Number($this.state.reserve_price),
            buyNowAmount: Number($this.state.buy_now_amount),
            type: $this.state.type,
            duration: $this.state.expire_duration ? Number($this.state.expire_duration) : 0
        };

        Service.postCall($this.state.url, data).then(response => {
            this.setState({
                error_message: Helping.getMessageString(CREATE, "Auction"),
                error_type: 'success',
                btnIsDisable: false
            }, () => { this.scrollToTop(); this.resetForm() });
        })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);

                    return $this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    },
                        () => { this.scrollToTop(); });
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "creating auction")
                }, () => { this.scrollToTop(); })
            });
    }

    render() {
        return (
            <div class="addButton-slide right-slider auction">
                <div class="slide-top">
                    <div class="slide-header">
                        <h4 class="title">Create Auction</h4>
                        <span class="caption">Create special auction and add information about it.</span>
                    </div>
                    {/* <span class="close-slide">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </span> */}
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }

                <form class="info">
                    <div class="form-group">
                        <label for="productID">Product ID</label>
                        <input type="number" name="nft_id" class={`form-control ${this.state.error_nft_id_message ? 'error-input' : ''}`} id="productID" value={this.state.nft_id} onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_nft_id_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="newAmount">Buy Now Amount($)</label>
                        <input type="number" name="buy_now_amount" class={`form-control ${this.state.error_buy_now_amount_message ? 'error-input' : ''}`} id="newAmount" value={this.state.buy_now_amount} onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_buy_now_amount_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="reserveAmount">Reserve Amount($)</label>
                        <input type="number" name="reserve_price" class={`form-control ${this.state.error_reserve_price_message ? 'error-input' : ''}`} id="reserveAmount" value={this.state.reserve_price} onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_reserve_price_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="auctionAmount">Auction Start Amount</label>
                        <input type="number" name="auction_start_amount" class={`form-control ${this.state.error_auction_start_amount_message ? 'error-input' : ''}`} id="auctionAmount" value={this.state.auction_start_amount} onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_auction_start_amount_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="type">Type</label>
                        <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} name="type" aria-label="" id="type" value={this.state.type} onChange={(e) => this.handleChange(e)}>
                            <option value='hours'>Hours</option>
                            <option value='days'>Days</option>
                        </select>
                        <span className="error-msg">{this.state.error_type_message}</span>
                    </div>
                    <div class="form-group">
                        <label for="expireDuration">Expire Duration in {this.state.type}</label>
                        <input type="number" name="expire_duration" class={`form-control ${this.state.error_expire_duration_message ? 'error-input' : ''}`} id="expireDuration" value={this.state.expire_duration} onChange={(e) => this.handleChange(e)} />
                        <span className="error-msg">{this.state.error_expire_duration_message}</span>
                    </div>
                    <div class="slide-btn">
                        <div className="float-left">
                            <button class="close-slide custom-btn semi-dark-btn sm-btn" onClick={e => e.preventDefault()}>Close</button>
                        </div>

                        <div class="float-right">
                            <button class="custom-btn semi-dark-btn sm-btn" onClick={(e) => { e.preventDefault(); this.resetForm() }}>Reset</button>

                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : this.state.buttonTitle}</button>
                            }
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile
    };
};

const mapDispatchToProps = {
    addItem
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);